import React from 'react'
import Icon from '../../../../../components/icon'
import Table from '../../../../../components/table'
import ITable from '../../../../../interfaces/table'
import {
  Container,
  Header,
  Input,
  InputWrapper,
  NewProductButton,
  Wrapper,
} from './styles'

type IProps = any & {
  tableData: ITable;
  setSearchTerm: (state: any) => void;
  searchTerm: string;
}

const ProfileList = ({
  tableData,
  goToEditor,
  setSearchTerm,
  searchTerm,
}: IProps) => (
  <Container>
    <Header>
      <InputWrapper>
        <Icon name="search" />
        <Input
          placeholder="Buscar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputWrapper>

      <NewProductButton onClick={goToEditor}>
        <Icon name="plus" />
        Novo perfil
      </NewProductButton>
    </Header>

    <Wrapper>
      <Table data={tableData} />
    </Wrapper>
  </Container>
)

export default ProfileList
